import type { DisplayLoyaltyTier, LoyaltyTierBadge as TierBadgeValue } from "@/api/orval/model";

import { TierBadge } from "./loyaltyEnums";
import type { TierBadgeEmblemName } from "./tierBadgeEmblems";
import { TierBadgeMedallion, type TierBadgeSize } from "./TierBadgeMedallion";

/** The API sends the badge as its number; each draws the emblem of the same name. */
const badgeEmblems: Record<TierBadgeValue, TierBadgeEmblemName> = {
  [TierBadge.Color]: "Color",
  [TierBadge.Initial]: "Initial",
  [TierBadge.Star]: "Star",
  [TierBadge.Gem]: "Gem",
  [TierBadge.Crown]: "Crown",
  [TierBadge.Heart]: "Heart",
  [TierBadge.Trophy]: "Trophy",
  [TierBadge.Medal]: "Medal",
  [TierBadge.Rosette]: "Rosette",
  [TierBadge.Laurel]: "Laurel",
  [TierBadge.Shield]: "Shield",
  [TierBadge.Diamond]: "Diamond",
  [TierBadge.Pearl]: "Pearl",
  [TierBadge.Lotus]: "Lotus",
  [TierBadge.Sparkle]: "Sparkle",
  [TierBadge.Droplet]: "Droplet",
  [TierBadge.Feather]: "Feather",
  [TierBadge.Moon]: "Moon",
  [TierBadge.Sun]: "Sun",
};

type LoyaltyTierBadgeProps = {
  tier: Pick<DisplayLoyaltyTier, "name" | "colorHex" | "badge">;
  size: TierBadgeSize;
  className?: string;
};

/** The tier's badge, its emblem or initial in the tier colour, as staff see it in Admin. */
export const LoyaltyTierBadge = ({ tier, size, className }: LoyaltyTierBadgeProps) => (
  <TierBadgeMedallion
    className={className}
    colorHex={tier.colorHex}
    emblem={badgeEmblems[tier.badge]}
    initial={tier.name.charAt(0).toUpperCase()}
    size={size}
  />
);
